module.exports = __webpack_public_path__ + "12b5965076d034b65c657804dbdb8639.svg";